import { useApprovalConfig } from './useApprovalConfig';
import { useApprovalData } from './useApprovalData';
import { useApprovalMeta } from './useApprovalMeta';
import type { ApprovalEntity } from 'ui-product-approvals-common';
import type { ApprovalProps } from '../types';

export const useApproval = ({
  approvalType,
  approvalAction,
  approvableObjectId,
  isFetchingApprovableObjectId,
  hasErrorFetchingApprovableObjectId,
  assetName,
  approvalObjectIds,
  previewSidebarContent,
  restartOnConclude,
}: ApprovalProps): ApprovalEntity => {
  const approvalConfig = useApprovalConfig(approvalType, approvalAction);
  const approvalData = useApprovalData(
    approvalType,
    approvalAction,
    approvableObjectId,
    assetName,
    approvalObjectIds
  );
  const api = {
    fetchConfig: approvalConfig.fetchConfig,
    ...approvalData.api,
  };

  const meta = useApprovalMeta({
    approvalType,
    approvalAction,
    approvableObjectId,
    isFetchingApprovableObjectId,
    hasErrorFetchingApprovableObjectId,
    assetName,
    approvalObjectIds,
    previewSidebarContent,
    restartOnConclude,
    approvalData,
    approvalConfig,
  });

  return {
    api,
    data: approvalData.data,
    config: approvalConfig.config,
    meta,
    previewSidebarContent,
  };
};
